import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import config from "../../../../config/config";
import { AppContext } from "../../../../context/AppContext";
import { TagsInput } from "react-tag-input-component";
import { toast } from "react-toastify";
// import Loader from "../../../../components/Loader/Loader";
// import { Field } from "formik";

// let VariationlistData = [];
// let VariationOptions = [];
const ItemVariactionTableRows = ({
  newVariation,
  rowsData,
  DropdownOptions,
  deleteTableRows,
  handleChange,
}) => {
  const token = localStorage.getItem("Token");
  const paramObject = useParams();
  // const [loading, setLoading] = useState(false);
  const [SelectedVariation, setSelectedVariation] = useState([]);
  const [Suppliers, setSuppliers] = useState([]);
  const { fetchItemVariation } = useContext(AppContext);
  console.log("DropdownOptions 26", DropdownOptions);

  //Supplies comma separated
  let Supplierlist = [];
  Suppliers?.map((u, i) => {
    Supplierlist[i] = { label: u.Name, value: u.ID };
  });

  console.log(Suppliers,"suppliers34");

  const handleSuppliers = (index, event) => {
    //object for sent values for handlechnage
    let evnt = {
      target: {
        name: "SupplierId",
        value: event?.map((el) => el.value)?.join(","),
      },
    };

    console.log("event 45", event);
    handleChange(index, evnt);
  };

  const handleItemNumbers = (index, event) => {
    //object for sent values for handlechnage

    console.log(event[event.length - 1], "CHECKING VALUE EVEENT");
    let duplicate = false;

    rowsData?.map((data) => {
      const arr = data.VariationItemNumber.split(",");
      console.log(arr.length, event.length, "check both array");

      if (rowsData[index].VariationItemNumber.split(",").length < event.length) {
        if (arr.includes(event[event.length - 1])) {
          toast.error("Duplicate Item Number Detected in this item.. ");
        }
        console.log(arr, event[event.length - 1], duplicate, "checking ssame");
      }
    });
    //   if(arr.includes(event[event.length - 1])){
    //     duplicate = true
    //   }
    //   console.log(arr, event[event.length - 1], duplicate, "checking ssame");
    // });

    if (event !== "" && event !== null && event !== undefined) {
      console.log(event, "checking ssame");
      let evnt = {
        target: {
          name: "VariationItemNumber",
          value: event?.join(","),
        },
      };

      handleChange(index, evnt);
    }
  };

  const handleVariation = (index, event) => {
    let x = event;
    // let i = 0;
    // let a = x[x?.length - 1];
    // for (i = 0; i < x?.length - 1; i++) {
    //   let b = x[i];
    //   if (a.attributeid === b.attributeid) {
    //     x?.splice(i, 1);
    //   }
    // }
    console.log("x 79 ===>", x, event);
    // console.log("x 79 ===>", event);

    const values = x?.map((option) => option.value)?.join(",");
    SelectedVariation[index] = values;
    handleChange(index, SelectedVariation[index]);
  };

  useEffect(() => {
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSuppliers(res.data.ResponseData);
        console.log("res.data.ResponseData 90", res.data.ResponseData);
      });
  }, [fetchItemVariation]);

  return rowsData?.map((data, index) => {
    const {
      ItemVariationId,
      VariationName,
      VariationAttributes,
      VariationItemNumber,
      VariationID,
      SupplierId,
      VariationProductId,
    } = data;
    console.log("VariationItemNumber ===>", VariationItemNumber);
    console.log("data 106", data);
    console.log("SupplierId 104", Supplierlist, SupplierId);

    let VariationOptions = [];
    const Variations = DropdownOptions?.map((u, i) => {
      VariationOptions[i] = {
        label: u.Name,
        value: u.ID,
        attributeid: u.Attributeid,
      };
    });

    let AttributeIdArray = [];

    if (VariationAttributes != "") {
      const newValue = VariationAttributes?.trim()
        ?.split(",")
        ?.map((str) => Number(str?.trim()));
      AttributeIdArray = newValue;
    }

    let SupplierArray = [];
    SupplierArray = SupplierId !== undefined ? [SupplierId] : "";

    const selectStyles = {
      control: (provided) => ({
        ...provided,
        width: "100%",
        height: "40px",
        position: "relative",
      }), // dropdown input css
      menu: () => ({
        boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
        position: "absolute",
        background: "#f8f8f8",
        width: "100%",
        zIndex: 99,
      }), // dropdown menu css
    };

    console.log("Supplierlist 153", Supplierlist, SupplierId);

    return (
      <>
        <tr key={index}>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            <input
              type="text"
              name="VariationProductId"
              id="VariationProductId"
              className="form-control"
              value={VariationProductId}
              onChange={(event) => handleChange(index, event)}
            />
          </td>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            <input
              type="text"
              name="VariationName"
              id="VariationName"
              className="form-control"
              value={data?.VariationName}
              onChange={(event) => handleChange(index, event)}
            />
          </td>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            <Select
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              hideSelectedOptions={true}
              isMulti={true}
              isClearable={true}
              onChange={(event) => handleVariation(index, event)}
              options={VariationOptions}
              placeholder=""
              // styles={selectStyles}
              value={VariationOptions?.filter((obj) =>
                AttributeIdArray?.includes(obj.value)
              )}
              id="VariationAttributes"
              name="VariationAttributes"
            />
          </td>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            <TagsInput
              type="text"
              placeHolder="press enter for tag"
              name="VariationItemNumber"
              id="VariationItemNumber"
              className=""
              value={
                VariationItemNumber != ""
                  ? VariationItemNumber?.split(",").map((d) => d.trim())
                  : []
              }
              onChange={(evnt) => handleItemNumbers(index, evnt)}
            />
          </td>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            {data?.VariationID}
          </td>
          <td style={{ padding: "0.1rem", margin: "0" }}>
            {/* <span style={{ fontSize: "10px" }}>
              {Supplierlist?.filter((obj) => SupplierId?.split(",").map((id) => parseInt(id.trim()) )?.includes(obj.value))
                ?.map((el) => el.label)
                ?.join(",")}
            </span> */}
            <Select
              backspaceRemovesValue={false}
              controlShouldRenderValue={true}
              hideSelectedOptions={true}
              isMulti={true}
              onChange={(event) => handleSuppliers(index, event)}
              options={Supplierlist}
              placeholder=""
              // styles={selectStyles}
              value={Supplierlist?.filter((obj) =>
                SupplierId?.split(",")
                  .map((id) => parseInt(id.trim()))
                  ?.includes(obj.value)
              )}
              id="SupplierId"
              name="SupplierId"
              style={{ width: "10rem" }}
            />
          </td>
          <td style={{ paddingTop: "1rem" }}>
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
              onClick={() => deleteTableRows(index)}
            />
          </td>
        </tr>
      </>
    );
  });
};

export default ItemVariactionTableRows;
